import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlugsComponent } from './flugs.component';
import { FlugsRoutingModule } from './flugs-routing.module';

import { AngularMaterialModule } from '../../material.module';
import { FooterModule } from '../footer/footer.module';
import { HeaderModule } from '../header/header.module';
import { FilterModule } from '../filter/filter.module';
import { ExtrafiltersModule } from '../extrafilters/extrafilters.module';
import { FlugcardComponent } from './flugcard/flugcard.component';
import { FlugdataComponent } from './flugdata/flugdata.component';
import { CallcenterusersModule } from '../callcenterusers/callcenterusers.module';
import { ShareComponent } from '../share/share.component';
@NgModule({
    declarations: [FlugsComponent, FlugcardComponent, FlugdataComponent],
    imports: [
        CommonModule,
        FlugsRoutingModule,
        AngularMaterialModule,
        FooterModule,
        ExtrafiltersModule,
        HeaderModule,
        FilterModule,
        CallcenterusersModule,
        ShareComponent
    ],
    exports: [
        FlugsComponent
    ]
})
export class FlugsModule { }
